import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';

const LanguageSelector = ({ currentLocale, changeLocale }) => {
  const handleLanguageChange = (event) => {
    const newLocale = event.target.value;
    localStorage.setItem('locale', newLocale);
    changeLocale(newLocale);
  };

  return (
    <div style={{ marginBottom: '24px' }}>
      <Typography
        variant="caption"
        component="div"
        sx={{
          color: 'rgba(0, 0, 0, 0.6)',
          marginBottom: '8px',
          fontSize: '0.75rem',
          fontWeight: 400,
          lineHeight: 1.2
        }}
      >
        Preferred Language
      </Typography>
      <FormControl fullWidth variant="outlined" size="small">
        <Select
          value={currentLocale || 'en'}
          onChange={handleLanguageChange}
          displayEmpty
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23)'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.87)'
            }
          }}
        >


<MenuItem value="en">English</MenuItem>

<MenuItem value="fr">French</MenuItem>

<MenuItem value="es">Spanish</MenuItem>
<MenuItem value="cn">Chinese </MenuItem>

<MenuItem value="hi">Hindi </MenuItem>

<MenuItem value="ar">Arabic </MenuItem>
<MenuItem value="pt">Portuguese </MenuItem>
<MenuItem value="id">Indonesian  </MenuItem>
<MenuItem value="it">Italian  </MenuItem>
<MenuItem value="ko">Korean  </MenuItem>
<MenuItem value="ja">Japanese  </MenuItem>
<MenuItem value="ru">Russian  </MenuItem>
<MenuItem value="de">German  </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default LanguageSelector;